import React, {FunctionComponent} from "react";
import {AnswerStatus} from "./questionConstants";
import Icon, {IconName} from "../../common/Icon";
import {createUseStyles} from "react-jss";
import {Theme} from "engage-client/theme";
import DisplayText, {TextVariant} from "engage-client/components/DisplayText";

type MCLabelProps = {
	selected?: boolean
	disabled?: boolean
	status?: AnswerStatus
	color: string
}

const useStyles = createUseStyles<Theme>((theme) => ({
	mcLabel: {
		position:"relative",
	},
	letter: {
		opacity: props => props.opacity,
		width: 30,
		height: 30,
		borderRadius: 15,
		[theme.breakpoints.between("sm","md")] : {
			width: 24,
			height: 24,
			borderRadius: 12,
		},
		[theme.breakpoints.only("xs")] : {
			width: 20,
			height: 20,
			borderRadius: 10,
		},
		border: "1px solid white",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		backgroundColor: props => props.fill,
	},
	icon: {
		position:"absolute",
		top: 3,
		left: 0,
		[theme.breakpoints.between("sm","md")] : {
			width: 26,
			height: 26
		},
		[theme.breakpoints.only("xs")] : {
			width: 22,
			height: 22
		},
	}
}));

const MultipleChoiceLabel:FunctionComponent<MCLabelProps> = (props) => {
	const {children, status = AnswerStatus.unknown, disabled = false, selected = false, color} = props;
	let textColor = "white";
	let fill = "unset";
	let icon = IconName.none;
	let opacity = disabled && !selected ? 0.3 : 1;
	if(selected) {
		fill = "white";
		textColor = color;
		if(status === AnswerStatus.correct) {
			icon = IconName.darkCheck;
		} else if (status === AnswerStatus.incorrect) {
			icon = IconName.darkX;
			opacity = 0.5;
		}
	} else {
		if(status === AnswerStatus.correct) {
			icon = IconName.whiteCheck;
			opacity = 0.5;
		}
	}

	const classes = useStyles({fill, opacity});

	return <div className={classes.mcLabel}>
		<DisplayText variant={TextVariant.s22reg} color={textColor} className={classes.letter}>{children}</DisplayText>
		<Icon className={classes.icon} name={icon}/>
	</div>;


};

export default MultipleChoiceLabel;